import styled from 'styled-components';
import { Tag } from 'antd';

export const StyledCheckableTag = styled(Tag.CheckableTag)<{ $checked?: boolean }>`
  border: 1px solid ${({ $checked }) => ($checked ? '#b7eb8f' : '#666')};
  background: ${({ $checked }) => ($checked ? '#f6ffed' : '#fff')};
  color: ${({ $checked }) => ($checked ? '#389e0d' : '#666')};
  transition: all 0.2s;
  font-weight: 500;
  margin-bottom: 5px;

  &:hover,
  &:active,
  &:focus {
    border-color: ${({ $checked }) => ($checked ? '#b7eb8f' : '#666')} !important;
    color: ${({ $checked }) => ($checked ? '#389e0d' : '#666')} !important;
    background: ${({ $checked }) => ($checked ? '#f6ffed' : '#fff')} !important;
    box-shadow: none !important;
  }
`;

export const FlowMainPanel = styled.div`
  padding: 4px 6px 12px 4px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 transparent;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 4px;
  }
`;

export const SidebarHeader = styled.div`
  padding: 16px 16px 8px;
`;

export const SidebarHeaderTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: rgb(0 0 0 / 65%);
  margin-bottom: 8px;
`;

export const LabelsSection = styled.div`
  padding: 10px;
  border-bottom: 1px solid rgb(240 240 240 / 100%);
`;

export const LabelsTitle = styled.div`
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: rgb(0 0 0 / 65%);
`;

export const LabelsGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

export const FlowItemName = styled.div`
  margin-bottom: 4px;
  display: flex;
  align-items: center;
`;

export const FlowItemTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
`;

export const DropdownTrigger = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
`;

export const DropdownIcon = styled.span`
  margin-left: 4px;
  display: flex;
  align-items: center;
`;

export const StyledFlowTag = styled(Tag)`
  font-size: 13px;
  font-weight: 600;
  padding: 0 8px;
  border-radius: 4px;
  margin-right: 8px;
`;

export const FlowLabel = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #222;
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FlowModalContent = styled.div`
  display: flex;
  width: 520px;
  min-height: 340px;
  max-height: 520px;
  background: #fff;
  overflow: hidden;
  border-radius: 8px;
  box-shadow:
    0 4px 16px -4px rgba(0 0 0 / 12%),
    0 0 0 1px rgba(0 0 0 / 4%);
  border: 1px solid #f0f0f0;
`;

export const FlowModalSidebar = styled.div`
  width: 132px;
  background: linear-gradient(#fafafa, #f5f5f5);
  border-right: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
`;

export const StageMenuItem = styled.div<{ $isActive: boolean }>`
  padding: 11px 14px;
  font-size: 13px;
  font-weight: ${({ $isActive }) => ($isActive ? 600 : 500)};
  color: ${({ $isActive }) => ($isActive ? '#0958d9' : '#555')};
  background: ${({ $isActive }) => ($isActive ? '#e6f4ff' : 'transparent')};
  cursor: pointer;
  border-left: 3px solid ${({ $isActive }) => ($isActive ? '#0958d9' : 'transparent')};
  transition:
    background 0.18s ease,
    color 0.18s ease;

  &:hover {
    background: ${({ $isActive }) => ($isActive ? '#e6f4ff' : '#f2f2f2')};
  }
`;

export const FlowModalMain = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: 0;
  overflow: hidden;
`;

export const SearchWrapper = styled.div`
  padding: 8px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
  border-bottom: 1px solid #f0f0f0;
`;

export const FlowItem = styled.div<{
  $isSelected: boolean;
  $type: 'flow' | 'frustration-signal' | 'event'| 'preset';
}>`
  padding: 10px 12px 8px;
  margin: 6px 4px;

  /* Base backgrounds tuned per type for subtle color presence */
  background: ${({ $isSelected, $type }) => {
    if ($isSelected) {
      if ($type === 'flow') return 'linear-gradient(135deg,#f6ffed 0%, #eaffd3 100%)';
      if ($type === 'frustration-signal') return 'linear-gradient(135deg,#fff1f0 0%, #ffe1df 100%)';
      if ($type === 'event') return 'linear-gradient(135deg,#e6f7ff 0%, #bae7ff 100%)';
      if ($type === 'preset') return 'linear-gradient(135deg, #e6f4ff 0%, #d6ebff 100%)';
    }
    return '#fff';
  }};
  border: 1px solid
    ${({ $isSelected, $type }) => {
      if ($isSelected) {
        if ($type === 'flow') return '#b7eb8f';
        if ($type === 'frustration-signal') return '#ffccc7';
        if ($type === 'event') return '#91d5ff';
        if ($type === 'preset') return '#d9d9d9';
      }
      return '#e8e8e8';
    }};
  border-left: 5px solid
    ${({ $type }) => {
      if ($type === 'flow') return '#52c41a';
      if ($type === 'frustration-signal') return '#ff4d4f';
      if ($type === 'event') return '#1890ff';
      if ($type === 'preset') return '#d9d9d9';
      return '#d9d9d9';
    }};
  cursor: pointer;
  border-radius: 6px;
  transition:
    background 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    background: ${({ $isSelected, $type }) => {
      if ($isSelected) {
        if ($type === 'flow') return 'linear-gradient(135deg,#f0ffdf 0%, #e3ffc2 100%)';
        if ($type === 'frustration-signal')
          return 'linear-gradient(135deg,#ffe9e7 0%, #ffd4d1 100%)';
        if ($type === 'event') return 'linear-gradient(135deg,#d6f0ff 0%, #a8deff 100%)';
        if ($type === 'preset') return 'linear-gradient(135deg,#e6f4ff 0%, #d6ebff 100%)';
      }
      return '#f7f9fa';
    }};
    border-color: ${({ $isSelected, $type }) => {
      if ($isSelected) {
        if ($type === 'flow') return '#95de64';
        if ($type === 'frustration-signal') return '#ffa39e';
        if ($type === 'event') return '#69c0ff';
        if ($type === 'preset') return '#d9d9d9';
      }
      return '#d0d0d0';
    }};
  }
`;

export const EmptyState = styled.div`
  padding: 48px 0;
  text-align: center;
  color: #aaa;
  font-size: 15px;
`;

export const FlowMetaTag = styled(Tag)`
  margin: 0;
  font-size: 11px;
  line-height: 16px;
  padding: 0 5px;
  border-radius: 3px;
  background: #f6ffed;
  color: #237804;
  border: 1px solid #b7eb8f;
  font-weight: 500;
`;
